import { render, staticRenderFns } from "./SnowDataTableField.vue?vue&type=template&id=e9076d6a&scoped=true&"
import script from "./SnowDataTableField.vue?vue&type=script&lang=js&"
export * from "./SnowDataTableField.vue?vue&type=script&lang=js&"
import style0 from "./SnowDataTableField.vue?vue&type=style&index=0&id=e9076d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9076d6a",
  null
  
)

export default component.exports